<nz-spin [nzSpinning]="loading$ | async">
  <nz-row class="center">
    <div #canvas></div>
  </nz-row>
  <nz-row class="center">
    <a
      nz-button
      nzType="primary"
      nzShape="round"
      [href]="getLink()"
      target="_blank"
    >
      <span nz-icon nzType="link" nzTheme="outline"></span>
      {{ "PROFILE.CONNECT_SUBSCRIBE" | translate }}
    </a>
  </nz-row>
</nz-spin>
